import { useMemo } from 'react';

import { resolveEventHealthStatus } from '@/features/workspace/helpers/nav-status';
import { usePurchaseEventHealth } from '@/features/setup/hooks/use-purchase-event-health';
import { useAccountState } from '@/contexts/account/account-context';

import type { AGGREGATED_HEALTH_STATUS } from '../types/use-integration-health-status-enums';

interface UseEventHealthStatusResult {
  status: AGGREGATED_HEALTH_STATUS;
  isLoading: boolean;
}

export function useEventHealthStatus(): UseEventHealthStatusResult {
  const { currentAccount } = useAccountState();
  const subscriptionId =
    currentAccount?.subscriptionId ?? currentAccount?.subscription?.id ?? '';
  const timestamp = useMemo(() => Date.now(), []);
  const { data, isLoading } = usePurchaseEventHealth(subscriptionId, timestamp);

  return useMemo(
    () => ({
      status: resolveEventHealthStatus(data?.data?.healthAttributes),
      isLoading,
    }),
    [data, isLoading]
  );
}
